// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ade74f6c","644":"f9bbbe91"}[chunkId] + ".chunk.js";
};